import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { X, Lock, AlertCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PasswordModal = ({ isOpen, onClose, onConfirm, title }) => {
  const [password, setPassword] = useState('');
  const { tt } = useLanguage();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API}/brand/verify-master-password`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      if (res.ok) {
        await onConfirm(password);
        setPassword('');
        onClose();
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || tt('Неверный пароль'));
      }
    } catch (err) {
      setError(tt('Ошибка проверки пароля'));
    }

    setLoading(false);
  };

  const handleClose = () => {
    setPassword('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <div className="flex items-center space-x-2">
            <Lock className="w-5 h-5 text-red-600" />
            <h3 className="text-lg font-semibold text-gray-900">{title || tt('Требуется пароль')}</h3>
          </div>
          <button onClick={handleClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-4">
            <div className="flex items-start space-x-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg mb-4">
              <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-yellow-800">
                {tt('Для выполнения этого действия требуется ввод мастер-пароля')}
              </p>
            </div>

            <label className="block text-sm font-medium text-gray-700 mb-2">
              {tt('Мастер-пароль')}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder={tt('Введите мастер-пароль')}
              autoFocus
              data-testid="master-password-input"
            />
            {error && (
              <p className="mt-2 text-sm text-red-600" data-testid="password-error">{error}</p>
            )}
          </div>

          <div className="flex space-x-3">
            <button type="button" onClick={handleClose} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
              {tt('Отмена')}
            </button>
            <button type="submit" disabled={loading || !password} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50" data-testid="confirm-password-btn">
              {loading ? tt('Проверка...') : tt('Подтвердить')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;
